import type {
  ApiResponse,
  ProductInventoryItem,
  ProductInventoryItemParams,
} from '@/libs/interfaces'

import {
  mockInventoryStatus,
  mockKPITotalBilled,
  mockKPITotalBookings,
  mockKPITotalServices,
} from '../fixtures/dashboard'
import { mockEmployees } from '../fixtures/seed'
import { delay } from '../helpers'

export const dashboardApiMock = {
  getKPITotalBilled: (
    _orgID: string,
    _storeID?: string,
    _from?: string,
  ): Promise<ApiResponse<{ data: { totalBilled: number } }>> =>
    delay({
      data: { data: { totalBilled: mockKPITotalBilled } },
      status: 200,
    }),

  getKPITotalBookings: (
    _orgID: string,
    _storeID?: string,
    _from?: string,
  ): Promise<ApiResponse<{ data: { totalBookings: number } }>> =>
    delay({
      data: { data: { totalBookings: mockKPITotalBookings } },
      status: 200,
    }),

  getKPITotalEmployees: (
    _orgID: string,
    _storeID?: string,
    _from?: string,
  ): Promise<ApiResponse<{ data: { totalEmployees: number } }>> =>
    delay({
      data: { data: { totalEmployees: mockEmployees.length } },
      status: 200,
    }),

  getKPITotalServices: (
    _orgID: string,
    _storeID?: string,
    _from?: string,
  ): Promise<ApiResponse<{ data: { totalServices: number } }>> =>
    delay({
      data: { data: { totalServices: mockKPITotalServices } },
      status: 200,
    }),

  getinventoryStatus: (_params: ProductInventoryItemParams): Promise<ProductInventoryItem[]> =>
    delay(mockInventoryStatus),
}
